import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  filtered: [],
  category: 'All',
  searchTerm: '',
  visibleCount: 20,
  hasMore: true,
  loading: false,
  scrollLoading: false,
  categories: [],
  isAtStart: true,
  isAtEnd: false,
  showScrollUp: false,
  showScrollDown: false,
  selectedUnit: 'All',
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
      state.filtered = action.payload.filter((p) => p.category?.name !== 'Cake');
      state.hasMore = state.filtered.length > state.visibleCount;
    },
    appendProducts: (state, action) => {
      const newProducts = [...state.products, ...action.payload];
      // Filter out duplicates by ID just in case
      const uniqueProducts = Array.from(new Map(newProducts.map(p => [p.id, p])).values());
      state.products = uniqueProducts;
      state.filtered = uniqueProducts.filter((p) => p.category?.name !== 'Cake');
      state.hasMore = state.filtered.length > state.visibleCount;
    },
    setFiltered: (state, action) => {
      state.filtered = action.payload;
      state.visibleCount = 20;
      state.hasMore = action.payload.length > 20;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setVisibleCount: (state, action) => {
      state.visibleCount = action.payload;
      state.hasMore = state.filtered.length > action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setScrollLoading: (state, action) => {
      state.scrollLoading = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setScrollState: (state, action) => {
      state.isAtStart = action.payload.isAtStart;
      state.isAtEnd = action.payload.isAtEnd;
    },
    setScrollButtons: (state, action) => {
      state.showScrollUp = action.payload.showScrollUp;
      state.showScrollDown = action.payload.showScrollDown;
    },
    setUnitFilter: (state, action) => {
      state.selectedUnit = action.payload;
      // state.visibleCount = 20;               
    },
  },
});

export const {
  setProducts,
  appendProducts,
  setFiltered,
  setCategory,
  setSearchTerm,
  setVisibleCount,
  setLoading,
  setScrollLoading,
  setCategories,
  setScrollState,
  setScrollButtons,
  setUnitFilter
} = productSlice.actions;

export default productSlice.reducer;